import './nuevoStroLight.css';
import { useCookies } from 'react-cookie';
import ModuloDenunciaChoquesLight from './ModuloDenunciaChoquesLight';
import ModuloDenunciaContractualesLight from './ModuloDenunciaContractualesLight';
import ModuloEstadoReclamoLight from './ModuloEstadoReclamoLight';
import ModuloGeneralStroNuevoLight from './ModuloGeneralStroNuevoLight';
import ModuloValoresReclamoNuevoLight from './ModuloValoresReclamoNuevoLight';
import ReclamoSeleccionado from './ReclamoSeleccionadoNuevo';
import EstadoReclamoBloqueLight from './EstadoReclamoBloqueLight';
import DocumentosNubeLight from './DocumentosNubeLight';
import { useCallback, useState } from 'react';
import axios from 'axios';
export default function MainStroLight({
  stro,
  carga3,
  estados,
  estadosCodigos,
  frente,
  sicobe,
  carga2,
  pagosAnteriores,
  cobert,
  reclamoSeleccionado,
  todosEstados,
  reclamos,
  reclamoSeleccionadoNuevo,
  setReclamoSeleccionadoNuevo,
  nuevoReclamo,
  setNuevoReclamo,
  terminoCargarTodoImportante,
}) {
  const [cookies] = useCookies(['user'], ['asignado']);
  const [responsabilidadNueva, setResponsabilidadNueva] = useState('');
  //
  const responsabilidadInput = [
    { label: 'Cr', value: 320 },
    { label: 'Cc', value: 320 },
    { label: 'Sr', value: 300 },
    { label: 'Rp', value: 400 },
    { label: 'Rp1 (1 ruedas)', value: 401 },
    { label: 'Rp2 (2 ruedas)', value: 402 },
    { label: 'Rp3 (3 ruedas)', value: 403 },
    { label: 'Rp4 (4 ruedas)', value: 404 },
    { label: 'Rp5 (5 ruedas)', value: 405 },
    { label: 'Rt', value: 500 },
    { label: 'Ra', value: 550 },
    { label: 'Raf', value: 551 },
    { label: 'Ip', value: 600 },
    { label: 'Dp', value: 800 },
    { label: 'Dt', value: 900 },
    { label: 'Aseg les', value: 100 },
    { label: 'Aseg muerto', value: 130 },
    { label: '3ro les', value: 200 },
    { label: '3ro muerto', value: 230 },
    { label: '3ro muerto Rec', value: 233 },
    { label: 'Rah', value: 590 },
  ];
  const handleChange1 = event => {
    setResponsabilidadNueva(event.target.value);
  };
  //
  const [asignado, setAsignado] = useState(null);
  const optionsCarga = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'StellaM', label: 'StellaM', key: 3 },
    { value: 'DanielaM', label: 'DanielaM', key: 4 },
    { value: 'rosario', label: 'rosario', key: 5 },
  ];
  const optionsChoque = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'DanielaM', label: 'DanielaM', key: 3 },
    { value: 'DiegoD', label: 'DiegoD', key: 4 },
    { value: 'DiegoS', label: 'DiegoS', key: 5 },
    { value: 'OrelyC', label: 'OrelyC', key: 6 },
    { value: 'StellaM', label: 'StellaM', key: 7 },
    { value: 'LucianaF', label: 'LucianaF', key: 8 },
    { value: 'CandelaS', label: 'CandelaS', key: 9 },
    { value: 'MagaliG', label: 'MagaliG', key: 10 },
    { value: 'PilarS', label: 'PilarS', key: 11 },
    { value: 'Maurom', label: 'Maurom', key: 12 },
    { value: 'ClaudiaF', label: 'ClaudiaF', key: 13 },
    { value: 'Gian', label: 'Gian', key: 14 },
    { value: 'rosario', label: 'rosario', key: 15 },
  ];
  const optionsContractuales = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'DanielaM', label: 'DanielaM', key: 3 },
    { value: 'DiegoD', label: 'DiegoD', key: 4 },
    { value: 'DiegoS', label: 'DiegoS', key: 5 },
    { value: 'OrelyC', label: 'OrelyC', key: 6 },
    { value: 'StellaM', label: 'StellaM', key: 7 },
    { value: 'LucianaF', label: 'LucianaF', key: 8 },
    { value: 'CandelaS', label: 'CandelaS', key: 9 },
    { value: 'MagaliG', label: 'MagaliG', key: 10 },
    { value: 'PilarS', label: 'PilarS', key: 11 },
    { value: 'Augusto', label: 'Augusto', key: 12 },
    { value: 'PaulaC', label: 'PaulaC', key: 13 },
    { value: 'MariaE', label: 'MariaE', key: 14 },
    { value: 'rosario', label: 'rosario', key: 15 },
  ];
  const handleChange2 = event => {
    setAsignado(event.target.value);
  };
  //
  const cargarNuevoReclamo = useCallback(
    async e => {
      e.preventDefault();
      try {
        await axios.post(`https://back.agsseguros.online/api/prueba/nuevoReclamo`, {
          nroStro: stro.nroStro,
          catStro: responsabilidadNueva,
          asignado: asignado,
        });

        // Recargar la página solo si el POST fue exitoso
        window.location.reload();
      } catch (error) {
        console.error('Error al crear el nuevo reclamo:', error);
        // Podés mostrar una notificación o mensaje al usuario si querés
      }
    },
    [stro?.id, responsabilidadNueva, asignado]
  );
  //
  return (
    <section className='mainStroDarkContenedor'>
      <section className='mainStroLightColIzq'>
        <ModuloGeneralStroNuevoLight
          denuncia={stro}
          carga3={carga3}
          estadosValores={estados}
          estadosCodigos={estadosCodigos}
          reclamos={reclamos}
          terminoCargarTodoImportante={terminoCargarTodoImportante}
        />
        {/* Se usaba hasta lo nuevo */}
        {/*<ModuloValoresReclamoNuevoLight reclamo={reclamoSeleccionado} carga3={carga3} denuncia={stro} />*/}
        {/*<ModuloEstadosStroLight denuncia={stro} carga3={carga3} estados={estados} />*/}
        {/* Se usaba hasta lo nuevo */}
        {/*<ModuloEstadoReclamoLight denuncia={reclamoSeleccionado} estados={reclamoSeleccionado} todosEstados={todosEstados} reclamo={reclamoSeleccionado} />*/}
        <section style={{ marginTop: '30px' }}>
          <div className='d-flex gap-3' style={{ paddingLeft: '20px' }}>
            {reclamos.map((r, index) => {
              const texto =
                r?.reclamo3ro?.tipoReclamante === 'PEATON' || r?.reclamo3ro?.tipoReclamante === 'PROPIEDAD'
                  ? r.reclamo3ro?.nombreReclamante
                  : r?.patente3ro
                    ? r.patente3ro
                    : responsabilidadInput.find(item => item.value === r.catStro)?.label || r.catStro;
              return (
                <button key={index} className={reclamoSeleccionadoNuevo?.id === r.id ? 'reclamosSeleccionado' : 'reclamosSeleccion'} onClick={() => setReclamoSeleccionadoNuevo(index)}>
                  {texto}
                </button>
              );
            })}
            <button className='cargarNuevoReclamoSeleccion' onClick={() => setNuevoReclamo(1)}>
              +
            </button>
          </div>
          {reclamoSeleccionado ? <ReclamoSeleccionado reclamo={reclamoSeleccionadoNuevo} stro={stro} /> : null}
          {nuevoReclamo ? (
            <>
              <div className='overlayOscuro' onClick={() => setNuevoReclamo(0)} />
              <form className='nuevoReclamoContainer' onSubmit={cargarNuevoReclamo}>
                <div className='d-flex justify-content-between align-items-center'>
                  <div className='nuevoReclamoTitulo'>INGRESAR TIPO DE SINIESTRO</div>
                  <button className='btnAgregarNuevoReclamo gap-2' type='submit'>
                    Agregar<i class='bi bi-caret-right-fill'></i>
                  </button>
                </div>
                <div style={{ marginTop: '15px' }}>
                  <span className='reclamoSpan'>Tipo de siniestro</span>
                  <select value={responsabilidadNueva} onChange={handleChange1} className='inputNuevoReclamo' required>
                    <option value=''> </option>
                    {responsabilidadInput.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ marginTop: '15px' }}>
                  <span className='reclamoSpan'>Asignado a (opcional)</span>
                  <select value={asignado} onChange={handleChange2} className='inputNuevoReclamo'>
                    <option value=''></option>
                    {cookies.user.depto === 'cargas' ? (
                      optionsCarga.map(option => (
                        <option key={option.key} value={option.value}>
                          {option.label}
                        </option>
                      ))
                    ) : cookies.user.depto === 'choques' ? (
                      optionsChoque.map(option => (
                        <option key={option.key} value={option.value}>
                          {option.label}
                        </option>
                      ))
                    ) : cookies.user.depto === 'contractuales' ? (
                      optionsContractuales.map(option => (
                        <option key={option.key} value={option.value}>
                          {option.label}
                        </option>
                      ))
                    ) : (
                      <></>
                    )}
                  </select>
                </div>
              </form>
            </>
          ) : null}
        </section>
      </section>
      <section className='mainStroLightColDer'>
        {cookies?.user?.depto === 'choques' ? (
          <ModuloDenunciaChoquesLight stro={stro} frente={frente} sicobe={sicobe} carga2={carga2} pagosAnteriores={pagosAnteriores} cobert={cobert} />
        ) : cookies?.user?.depto === 'contractuales' ? (
          <ModuloDenunciaContractualesLight stro={stro} frente={frente} sicobe={sicobe} carga2={carga2} pagosAnteriores={pagosAnteriores} cobert={cobert} />
        ) : null}
        {reclamoSeleccionado ? <EstadoReclamoBloqueLight reclamo={reclamoSeleccionadoNuevo} /> : null}
        <DocumentosNubeLight stro={stro} />
      </section>
    </section>
  );
}
